import { render, staticRenderFns } from "./MDDropdown.vue?vue&type=template&id=771c5bec"
import script from "./MDDropdown.vue?vue&type=script&lang=js"
export * from "./MDDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports